import { render, staticRenderFns } from "./manybo-gap.vue?vue&type=template&id=5b04822b&scoped=true"
import script from "./manybo-gap.vue?vue&type=script&lang=js"
export * from "./manybo-gap.vue?vue&type=script&lang=js"
import style0 from "./manybo-gap.vue?vue&type=style&index=0&id=5b04822b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04822b",
  null
  
)

export default component.exports